<template>
  <div class="loading-status" role="status" aria-live="polite">
    <UIcon name="i-heroicons-arrow-path" class="h-4 w-4 shrink-0 animate-spin" style="color:var(--acctext);" />
    <span>
      <span style="font-weight:600;">{{ label }}</span>
      <span v-if="slow" style="color:var(--muted); margin-left:6px;">{{ slowHint }}</span>
    </span>
  </div>
</template>

<script setup lang="ts">
// Says what is loading, in words, next to a spinner. Skeletons alone look like a
// finished empty page. After a few seconds it adds a second sentence so a long wait
// does not look like a hang.
const props = withDefaults(defineProps<{
  label: string
  /** Shown after `slowAfter` ms. */
  slowHint?: string
  slowAfter?: number
}>(), {
  slowHint: 'Still working.',
  slowAfter: 4000,
})

const slow = ref(false)
let timer: ReturnType<typeof setTimeout> | undefined
onMounted(() => { timer = setTimeout(() => { slow.value = true }, props.slowAfter) })
onBeforeUnmount(() => clearTimeout(timer))
</script>

<style scoped>
.loading-status {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 24px;
}
</style>
